import { Box, Typography } from '@mui/material';
import { Block } from '@mui/icons-material';

const TokenUnavailablePage = () => {
  return (
    <Box
      sx={{
        height: '80vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Block sx={{ fontSize: 160, color: 'error.main' }} />
      <Typography variant="h3" sx={{ mt: 2, color: 'error.main' }}>
        無法使用
      </Typography>
    </Box>
  );
};

export default TokenUnavailablePage;
